var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_close_24px","d":"M27.38,7.254,25.126,5,16.19,13.936,7.254,5,5,7.254l8.936,8.936L5,25.126,7.254,27.38l8.936-8.936,8.936,8.936,2.254-2.254L18.444,16.19Z","transform":"translate(-5 -5)","fill":"#efefef"}));
}

Close.defaultProps = {"width":"22.38","height":"22.38","viewBox":"0 0 22.38 22.38"};

module.exports = Close;

Close.default = Close;
